import React from 'react';

import { css, cx, keyframes } from '@emotion/css';

import { FontSizes } from '@/assets/fonts.ts';
import { Icons } from '@/assets/icons.ts';
import { useStyles } from '@/hooks/useStyles.ts';
import { Message } from '@/models/MessagingModel';
import { Queries } from '@/queries/Queries.ts';

export type DeleteMessageProps = {
  message: Message;
  hovering: boolean;
  userIsSender: boolean;
  className?: string;
};

export const DeleteMessage: React.FC<DeleteMessageProps> = ({
  message,
  hovering,
  userIsSender,
  className,
}) => {
  const styles = useStyles(makeStyles);
  const deleteMessage = Queries.messaging.useDeleteMessage();

  if (!userIsSender || message.deleted) {
    return null;
  }

  return (
    <div className={cx(styles.container, className)}>
      {hovering && (
        <Icons.trash
          className={styles.icon}
          onClick={() => {
            deleteMessage.mutate({
              patientId: message.subjectId,
              messageId: message.id,
            });
          }}
        />
      )}
    </div>
  );
};

const makeStyles = () => ({
  container: css({
    cursor: 'pointer',
  }),
  icon: css({
    width: FontSizes.body,
    height: FontSizes.body,
    animation: `${fadeIn} 1s forwards`,
  }),
});

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
